import React from 'react';

const ButtonLoader = ({ label = 'Working' }) => (
  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
    <span className="btn-spinner" />
    <span>{label}</span>
  </span>
);

export default ButtonLoader;
